import React, { useMemo, useRef } from 'react';

const OTPInput = ({ value = '', length = 4, onChange, disabled = false, masked = false }) => {
  const inputsRef = useRef([]);

  const values = useMemo(() => {
    const chars = value.split('').slice(0, length);
    while (chars.length < length) {
      chars.push('');
    }
    return chars;
  }, [value, length]);

  const focusInput = (index) => {
    if (inputsRef.current[index]) {
      inputsRef.current[index].focus();
      inputsRef.current[index].select();
    }
  };

  const handleChange = (index, event) => {
    const raw = event.target.value.replace(/\D/g, '');
    const nextValues = [...values];
    const char = raw.slice(-1);

    nextValues[index] = char || '';
    const nextValue = nextValues.join('').slice(0, length);
    onChange?.(nextValue);

    if (char && index < length - 1) {
      focusInput(index + 1);
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === 'Backspace' && !values[index] && index > 0) {
      event.preventDefault();
      const prevIndex = index - 1;
      const nextValues = [...values];
      nextValues[prevIndex] = '';
      onChange?.(nextValues.join('').slice(0, length));
      focusInput(prevIndex);
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const text = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, length);
    if (!text) return;

    onChange?.(text);
    if (text.length < length) {
      focusInput(text.length);
    } else {
      inputsRef.current[length - 1]?.blur();
    }
  };

  return (
    <div className="otp-input-wrapper">
      {values.map((char, index) => (
        <input
          key={index}
          type="text"
          inputMode="numeric"
          maxLength={1}
          className={`otp-input-box${masked ? ' otp-input-box--masked' : ''}`}
          value={char}
          autoComplete={masked ? 'off' : undefined}
          disabled={disabled}
          onChange={(event) => handleChange(index, event)}
          onKeyDown={(event) => handleKeyDown(index, event)}
          onPaste={handlePaste}
          ref={(el) => (inputsRef.current[index] = el)}
        />
      ))}
    </div>
  );
};

export default OTPInput;
